/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  GetApiCreditCardList200,
  GetApiCreditCardListParams,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiCreditCardListResponse200 = {
  data: GetApiCreditCardList200
  status: 200
}

export type getApiCreditCardListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiCreditCardListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiCreditCardListResponseSuccess = (getApiCreditCardListResponse200) & {
  headers: Headers;
};
export type getApiCreditCardListResponseError = (getApiCreditCardListResponse401 | getApiCreditCardListResponse403) & {
  headers: Headers;
};

export type getApiCreditCardListResponse = (getApiCreditCardListResponseSuccess | getApiCreditCardListResponseError)

export const getGetApiCreditCardListUrl = (params?: GetApiCreditCardListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/credit-cards/?${stringifiedParams}` : `/api/credit-cards/`
}

export const getApiCreditCardList = async (params?: GetApiCreditCardListParams, options?: RequestInit): Promise<getApiCreditCardListResponse> => {
  
  return customFetch<getApiCreditCardListResponse>(getGetApiCreditCardListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


